import { useTheme } from '@/app/platform/core/layout/themes/ThemeContext.tsx';

import React from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

export interface BreadcrumbTab {
  key: string;
  label: string;
  path: string;
  isActive: boolean;
  icon?: string | null;
}

export function getPageTitle(breadcrumbs?: BreadcrumbItem[]): string | undefined {
  return breadcrumbs && breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1].label : undefined;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const { theme } = useTheme();

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--space-sm)',
    fontSize: 'var(--font-sm)',
    color: theme.colors.text,
  };

  const itemStyle: React.CSSProperties = {
    color: theme.colors.text,
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    cursor: 'default',
  };

  const clickableItemStyle: React.CSSProperties = {
    ...itemStyle,
    cursor: 'pointer',
  };

  const activeItemStyle: React.CSSProperties = {
    ...itemStyle,
    color: theme.colors.text,
    fontWeight: 500,
  };

  const separatorStyle: React.CSSProperties = {
    color: theme.colors.text,
    userSelect: 'none',
  };

  return (
    <nav style={containerStyle} aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isClickable = !isLast && item.path;

        return (
          <React.Fragment key={index}>
            {isClickable && item.path ? (
              <Link
                to={item.path}
                style={{ ...clickableItemStyle, textDecoration: 'none' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = theme.colors.primary;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = theme.colors.text;
                }}
              >
                {item.label}
              </Link>
            ) : (
              <span style={isLast ? activeItemStyle : itemStyle}>
                {item.label}
              </span>
            )}
            {!isLast && <span style={separatorStyle}>/</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
